import { useResponsive } from '../../hooks/useResponsive';

const ResponsiveComponent = ({ mobileComponent: MobileComponent, desktopComponent: DesktopComponent, ...props }) => {
    const { isMobile } = useResponsive();

    // If mobile component is provided and we're on mobile, render mobile component
    if (isMobile && MobileComponent) {
        return <MobileComponent {...props} />;
    }

    // Otherwise, render desktop component (fallback to desktop if no mobile component provided)
    return <DesktopComponent {...props} />;
};

export default ResponsiveComponent;